let reset_form = (formId) =>  {
    let formSelector = `#${formId}`;
    let $form = $(formSelector);

    try {
        $form[0].reset();
    } catch (e) {}

    try {
        $form.find('select.select2').val('').trigger('change');
    } catch (e) {}

    window.LaravelValidation = window.LaravelValidation || {}
    if (window.LaravelValidation.hasOwnProperty(formSelector)) {
        window.LaravelValidation[formSelector].currentForm.reset();
        window.LaravelValidation[formSelector].resetForm();
    }
}

export default reset_form;
